import { motion } from 'framer-motion';
import { ArrowSwapHorizontal, Calculator, MathIcon } from '@/components/icons';
import { UnderlineTabs } from '@/components/system';
import WrapperLayout from '@/pages/components/WrapperLayout';
import { itemVariants, pageVariants } from '../dashboard/animations';
import ScoreConversionCalculator from './components/ScoreConversionCalculator';
import ZScoreCalculator from './components/ZScoreCalculator';

const TOOLS = [
    {
        value: 'conversion',
        label: 'Conversor de escores',
        icon: ArrowSwapHorizontal,
        content: <ScoreConversionCalculator />,
    },
    {
        value: 'z-score',
        label: 'Escore Z',
        icon: MathIcon,
        content: <ZScoreCalculator />,
    },
];

export default function ToolsPage() {
    return (
        <WrapperLayout title="Calculadoras" leftIcon={Calculator}>
            <motion.div variants={pageVariants} initial="hidden" animate="visible">
                <motion.div variants={itemVariants}>
                    <UnderlineTabs defaultValue="conversion" tabs={TOOLS} />
                </motion.div>
            </motion.div>
        </WrapperLayout>
    );
}
